var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.formload)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"text-md-center":""}},[_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}})],1)],1):_c('v-flex',[_c('highcharts',{ref:"highcharts",attrs:{"options":_vm.chartoptions}})],1),_c('faqs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }